import { ApiHelper } from './api.helper';
import { IStaffTravel } from '../types/staff-travel.type';
import { HttpUtils } from '../utils/http.utils';
import { IFilters, IRequestParams } from '../views/StaffTravel/types';

export const fetchStaffTravel = async (filters: IFilters): Promise<IStaffTravel[]> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('staff/travel')}?${queryParams}`;
  const response = await fetch(url, ApiHelper.makeOptions());
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const downloadStaffTravel = async (filters: IFilters): Promise<Blob> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('staff/travel/export')}?${queryParams}`;

  const response = await fetch(url, ApiHelper.makeOptions());
  const data = response.blob();

  if (!response.ok) {
    const responseData = await response.json();

    throw new Error(await responseData.message);
  }

  return data;
};
